import { render, staticRenderFns } from "./TableTicket.vue?vue&type=template&id=2d8b45f4&"
import script from "./TableTicket.vue?vue&type=script&lang=ts&"
export * from "./TableTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports